const END_POINT="https://pink-naughty-seagull.cyclic.app"
export default END_POINT